

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {MotoristaMensagemPush} from '@/model/resource/MotoristaMensagemPush'
import {MotoristaMensagemPushCollection} from '@/model/collection/MotoristaMensagemPushCollection'
import {ListMotoristaMensagemPushSchema} from '@/schema/resource/MotoristaMensagemPush/ListMotoristaMensagemPushSchema'
import {CsvMotoristaMensagemPushSchema} from '@/schema/resource/MotoristaMensagemPush/CsvMotoristaMensagemPushSchema'

@Component
export default class ListMotoristaMensagemPushView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListMotoristaMensagemPushSchema()
  collection = new MotoristaMensagemPushCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: MotoristaMensagemPush) {
    Helper.pushByName('editMotoristaMensagemPush', item.$id)
  }

  async removeItem(item: MotoristaMensagemPush) {
    await new DialogRemove(item).confirm(() =>
      item.removeMotoristaMensagemPush()
    )
    await this.collection.listMotoristaMensagemPush()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new MotoristaMensagemPushCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvMotoristaMensagemPush()
    new CsvMotoristaMensagemPushSchema().downloadCsv(csv.all())
  }
}
